import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {TopAlertInformacja} from "../../../../../componentsTopsa/alerty/TopAlerts";


export default class WynajemContainer extends Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem('EBUS_EdycjaWynajem') === null){
            this.state = {
                nazwa: '',
                telefon: '',
                email: '',
                uwagi: ''
            };
        } else {
            this.state = {
                nazwa: this.props.data.nazwa,
                telefon: this.props.data.telefon,
                email: this.props.data.email,
                uwagi: this.props.data.uwagi
            };
        }

        this.onChangeNazwa = this.onChangeNazwa.bind(this);
        this.onChangeTelefon = this.onChangeTelefon.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeUwagi = this.onChangeUwagi.bind(this);
    }

    onChangeNazwa(e) {
        this.setState({nazwa: e.target.value})
        this.props.setNazwa(e.target.value)
    }

    onChangeTelefon(e) {
        this.setState({telefon: e.target.value})
        this.props.setTelefon(e.target.value)
    }

    onChangeEmail(e) {
        this.setState({email: e.target.value})
        this.props.setEmail(e.target.value)
    }

    onChangeUwagi(e) {
        this.setState({uwagi: e.target.value})
        this.props.setUwagi(e.target.value)
    }

    render() {
        return (
            <Col sm={6} style={{marginTop: 15, marginBottom: 15}}>
                <fieldset>
                    <div className={'fieldset-label'}>Dane klienta</div>
                    <Form horizontal={true}>
                        <FormGroup>

                            <Col xs={12} lg={12}>
                                <ControlLabel>Imię i nazwisko / Nazwa firmy: <span
                                    style={{color: 'dodgerblue'}}>*</span></ControlLabel>
                                <input className="form-control" maxLength={30} onChange={this.onChangeNazwa}
                                       value={this.state.nazwa}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={6}>
                                <ControlLabel>Numer telefonu: <span
                                    style={{color: 'dodgerblue'}}>*</span></ControlLabel>
                                <input className="form-control" maxLength={20} onChange={this.onChangeTelefon}
                                       value={this.state.telefon}/>
                            </Col>
                            <Col xs={12} lg={6}>
                                <ControlLabel>E-mail: <span style={{color: 'dodgerblue'}}>*</span></ControlLabel>
                                <input className="form-control" maxLength={200} onChange={this.onChangeEmail}
                                       value={this.state.email}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={12}>
                                <ControlLabel>Uwagi:</ControlLabel>
                                <input className="form-control"
                                       onChange={this.onChangeUwagi}
                                       value={this.state.uwagi} maxLength={1000}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={12}>
                                <TopAlertInformacja
                                    text={'Należy uzupełnić przynajmniej jedno z powyższych pól oznaczonych gwiazdką w celu identyfikacji klienta: Imię i nazwisko lub nazwa firmy / Telefon / Email'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup/>
                    </Form>
                </fieldset>
            </Col>

        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/formularz/components/DaneKlienta.js